import TableCell from '@material-ui/core/TableCell';
import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';

export const ActionTableCell = styled(TableCell)`
    text-align: right;
    padding: 6px 16px;
`;

export const FlexContainer = styled.div`
    display: flex;
`;

export const Title = styled(Typography)`
    color: rgba(0, 0, 0, 0.87);
    flex: 1;
`;
